import immutableUpdate from "immutable-update";

const initialState = {
  categories: null,
};

const reducers = {
  CATEGORIES_LOADED: (state, action) => {

    if (state.categories !== null) {
      return immutableUpdate(state, {
        categories: state.categories,
      });
    } else {
      return immutableUpdate(state, {
        categories: action.payload.data.categorias,
      });
    }
  },
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;
